export const breakpoints = {
  mobile: "480px",
};
